/**
	!! AUTOGENERATED DO NOT EDIT !!
	by tools/scss-to-js-generator script 
*/
export default {
  'light-neutral-default': '#fff',
  'dark-neutral-default': '#000000',
  'logo-rich-black': '#101e2e',
  'light-neutral-10': '#fbfcfd',
  'light-neutral-20': '#f8f9fa',
  'light-neutral-30': '#f1f3f5',
  'light-neutral-40': '#eceef0',
  'light-neutral-50': '#e6e8eb',
  'light-neutral-60': '#dfe3e6',
  'light-neutral-70': '#d7dbdf',
  'light-neutral-80': '#c1c8cd',
  'light-neutral-90': '#889096',
  'light-neutral-100': '#7e868c',
  'light-neutral-110': '#687076',
  'light-neutral-120': '#11181c',
  'light-primary-10': '#fbfdff',
  'light-primary-20': '#f5faff',
  'light-primary-30': '#edf6ff',
  'light-primary-40': '#e1f0ff',
  'light-primary-50': '#cee7fe',
  'light-primary-60': '#b7d9f8',
  'light-primary-70': '#96c7f2',
  'light-primary-80': '#5eb0ef',
  'light-primary-90': '#0091ff',
  'light-primary-100': '#0081f1',
  'light-primary-110': '#006adc',
  'light-primary-120': '#00254d',
  'light-error-10': '#fffcfc',
  'light-error-20': '#fff8f8',
  'light-error-30': '#ffefef',
  'light-error-40': '#ffe5e5',
  'light-error-50': '#fdd8d8',
  'light-error-60': '#f9c6c6',
  'light-error-70': '#f3aeaf',
  'light-error-80': '#eb9091',
  'light-error-90': '#e5484d',
  'light-error-100': '#dc3d43',
  'light-error-110': '#cd2b31',
  'light-error-120': '#381316',
  'light-warning-10': '#fefcfb',
  'light-warning-20': '#fef8f4',
  'light-warning-30': '#fff1e7',
  'light-warning-40': '#ffe8d7',
  'light-warning-50': '#ffdcc3',
  'light-warning-60': '#ffcca7',
  'light-warning-70': '#ffb381',
  'light-warning-80': '#fa934e',
  'light-warning-90': '#f76808',
  'light-warning-100': '#ed5f00',
  'light-warning-110': '#bd4b00',
  'light-warning-120': '#451e11',
  'light-success-10': '#fbfefc',
  'light-success-20': '#f2fcf5',
  'light-success-30': '#e9f9ee',
  'light-success-40': '#ddf3e4',
  'light-success-50': '#ccebd7',
  'light-success-60': '#b4dfc4',
  'light-success-70': '#92ceac',
  'light-success-80': '#5bb98c',
  'light-success-90': '#30a46c',
  'light-success-100': '#299764',
  'light-success-110': '#18794e',
  'light-success-120': '#153226',
  'light-yellow-30': '#fffbd1',
  'light-yellow-40': '#fff8bb',
  'light-yellow-60': '#f9e68c',
  'light-yellow-80': '#ebbc00',
  'light-yellow-90': '#f5d90a',
  'light-yellow-110': '#946800',
  'light-yellow-120': '#35290f',
  'light-mint-30': '#e1fbf4',
  'light-mint-40': '#d2f7ed',
  'light-mint-60': '#a5e4d4',
  'light-mint-80': '#40c4aa',
  'light-mint-90': '#70e1c8',
  'light-mint-110': '#147d6f',
  'light-mint-120': '#09342e',
  'light-plum-30': '#fceffc',
  'light-plum-40': '#f9e5f9',
  'light-plum-60': '#ebc8ed',
  'light-plum-80': '#cf91d8',
  'light-plum-90': '#ab4aba',
  'light-plum-110': '#9c2bad',
  'light-plum-120': '#340c3b',
  'light-grass-30': '#ebf9eb',
  'light-grass-40': '#dff3df',
  'light-grass-60': '#b7dfba',
  'light-grass-80': '#65ba75',
  'light-grass-90': '#46a758',
  'light-grass-110': '#297c3b',
  'light-grass-120': '#1b311e',
  'light-brown-30': '#f8f1ea',
  'light-brown-40': '#f4e9dd',
  'light-brown-60': '#e8cdb5',
  'light-brown-80': '#d09e72',
  'light-brown-90': '#ad7f58',
  'light-brown-110': '#886349',
  'light-brown-120': '#3f2c22',
  'light-orange-30': '#fff1e7',
  'light-orange-40': '#ffe8d7',
  'light-orange-60': '#ffcca7',
  'light-orange-80': '#fa934e',
  'light-orange-90': '#f76808',
  'light-orange-110': '#bd4b00',
  'light-orange-120': '#451e11',
  'dark-neutral-10': '#151718',
  'dark-neutral-20': '#1a1d1e',
  'dark-neutral-30': '#202425',
  'dark-neutral-40': '#26292b',
  'dark-neutral-50': '#2b2f31',
  'dark-neutral-60': '#313538',
  'dark-neutral-70': '#3a3f42',
  'dark-neutral-80': '#4c5155',
  'dark-neutral-90': '#697177',
  'dark-neutral-100': '#787f85',
  'dark-neutral-110': '#9ba1a6',
  'dark-neutral-120': '#ecedee',
  'dark-primary-10': '#0f1720',
  'dark-primary-20': '#0f1b2d',
  'dark-primary-30': '#10243e',
  'dark-primary-40': '#102a4c',
  'dark-primary-50': '#0f3058',
  'dark-primary-60': '#0d3868',
  'dark-primary-70': '#0a4481',
  'dark-primary-80': '#0954a5',
  'dark-primary-90': '#0091ff',
  'dark-primary-100': '#369eff',
  'dark-primary-110': '#52a9ff',
  'dark-primary-120': '#eaf6ff',
  'dark-error-10': '#1f1315',
  'dark-error-20': '#291415',
  'dark-error-30': '#3c181a',
  'dark-error-40': '#481a1d',
  'dark-error-50': '#541b1f',
  'dark-error-60': '#671e22',
  'dark-error-70': '#822025',
  'dark-error-80': '#aa2429',
  'dark-error-90': '#e5484d',
  'dark-error-100': '#f2555a',
  'dark-error-110': '#ff6369',
  'dark-error-120': '#feecee',
  'dark-warning-10': '#1f1206',
  'dark-warning-20': '#2b1400',
  'dark-warning-30': '#391a03',
  'dark-warning-40': '#441f04',
  'dark-warning-50': '#4f2305',
  'dark-warning-60': '#5f2a06',
  'dark-warning-70': '#763205',
  'dark-warning-80': '#943e00',
  'dark-warning-90': '#f76808',
  'dark-warning-100': '#ff802b',
  'dark-warning-110': '#ff8b3e',
  'dark-warning-120': '#feeadd',
  'dark-success-10': '#0d1912',
  'dark-success-20': '#0c1f17',
  'dark-success-30': '#0f291e',
  'dark-success-40': '#113123',
  'dark-success-50': '#133929',
  'dark-success-60': '#164430',
  'dark-success-70': '#1b543a',
  'dark-success-80': '#236e4a',
  'dark-success-90': '#30a46c',
  'dark-success-100': '#3cb179',
  'dark-success-110': '#4cc38a',
  'dark-success-120': '#e5fbeb',
};
